import { SVGProps, Ref, forwardRef } from 'react';

export const YandexGrayscaleSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M14.797 3.974h-1.711c-3.137 0-4.787 1.59-4.787 3.932 0 2.649 1.14 3.89 3.483 5.48l1.935 1.304L8.156 23H4l4.991-7.434C6.121 13.508 4.51 11.51 4.51 8.13 4.51 3.893 7.463 1 13.066 1h5.561v21.98h-3.83z"
            fill="#919191"
        />
    </svg>
));
YandexGrayscaleSize24Glyph.displayName = 'YandexGrayscaleSize24Glyph';
